import clsx from 'clsx'

import type { QuickLinksSource } from '../types'

interface Props {
  source: QuickLinksSource
  highlighted: boolean
  stretchX: string
  titleSizeClass: string
}
export const TitleField = ({
  source,
  highlighted,
  stretchX,
  titleSizeClass,
}: Props) => {
  return (
    <div className={clsx(stretchX, 'break-words min-w-0')}>
      <h2
        className={clsx(
          'text-content line-clamp-3',
          titleSizeClass,
          highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        )}
      >
        {source.title}
      </h2>
    </div>
  )
}
